import Image from '@tiptap/extension-image';
import { NodeViewProps, ReactNodeViewRenderer } from '@tiptap/react';
import { ComponentType } from 'react';
import ImageResizeComponent, {
  ImageAttributes,
} from '../components/ImageResize';

export const ImageResize = Image.extend({
  addAttributes() {
    return {
      ...this.parent?.(),
      width: {
        default: '100%',
        renderHTML: (attributes: ImageAttributes) => ({
          width: attributes.width,
        }),
        parseHTML: (element) => element.style.width || '100%',
      },
      height: {
        default: 'auto',
        renderHTML: (attributes: ImageAttributes) => ({
          height: attributes.height,
        }),
        parseHTML: (element) => element.style.height || 'auto',
      },
      alignment: {
        default: 'none',
        renderHTML: (attributes: ImageAttributes) => ({
          class: `image-align-${attributes.alignment}`,
        }),
        parseHTML: (element) => {
          const classList = element.classList;
          if (classList.contains('image-align-left')) return 'left';
          if (classList.contains('image-align-center')) return 'center';
          if (classList.contains('image-align-right')) return 'right';
          return 'none';
        },
      },
    };
  },
  addNodeView() {
    return ReactNodeViewRenderer(
      ImageResizeComponent as unknown as ComponentType<NodeViewProps>
    );
  },
  parseHTML() {
    return [
      {
        tag: 'img[src]',
        getAttrs: (element) => {
          if (typeof element === 'string') return {};
          const img = element as HTMLImageElement;
          return {
            src: img.getAttribute('src'),
            alt: img.getAttribute('alt'),
            title: img.getAttribute('title'),
            width: img.style.width,
            height: img.style.height,
            alignment: img.className.match(/image-align-(left|center|right)/)
              ? img.className.match(/image-align-(left|center|right)/)![1]
              : 'none',
          };
        },
      },
    ];
  },
  renderHTML({ HTMLAttributes }) {
    const { alignment, ...attrs } = HTMLAttributes;
    return [
      'img',
      {
        ...attrs,
        class: `image-align-${alignment}`,
        style: `width: ${attrs.width}; height: ${attrs.height};`,
      },
    ];
  },
  draggable: true,
});

export default ImageResize;
